const DRAG_DROP_MATRIX = [
    {source: "garrison", target: "attendance", sourceState: "available", targetState: "onHold", reversible: true, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "available", targetState: "inProgress", reversible: true, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "available", targetState: "panic", reversible: true, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "available", targetState: "delayed", reversible: true, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "available", targetState: "schedule", reversible: true, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "dispatch", targetState: "delayed", reversible: true, action: "queue"},
    {source: "garrison", target: "attendance", sourceState: "dispatch", targetState: "schedule", reversible: true, action: "queue"},
    {source: "garrison", target: "attendance", sourceState: "dispatch", targetState: "onHold", reversible: true, action: "queue"},
    {source: "garrison", target: "attendance", sourceState: "dispatchSupport", targetState: "delayed", reversible: true, action: "queue"},
    {source: "garrison", target: "attendance", sourceState: "dispatchSupport", targetState: "onHold", reversible: true, action: "queue"},
    {source: "garrison", target: "attendance", sourceState: "dispatchSupport", targetState: "schedule", reversible: true, action: "queue"},
    {source: "garrison", target: "attendance", sourceState: "dispatchActivity", targetState: "onHold", reversible: true, action: "choice"},
    {source: "garrison", target: "attendance", sourceState: "dispatchActivity", targetState: "inProgress", reversible: false, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "dispatchActivity", targetState: "panic", reversible: true, action: "dispatch"},
    {source: "garrison", target: "attendance", sourceState: "dispatchActivity", targetState: "schedule", reversible: true, action: "choice"},
    {source: "garrison", target: "attendance", sourceState: "dispatchActivity", targetState: "delayed", reversible: true, action: "choice"},
    {source: "garrison", target: "attendance", sourceState: "panic", targetState: "onHold", reversible: true, action: "dispatch", condition: "garrisonWithoutDispatch"},
    {source: "garrison", target: "attendance", sourceState: "panic", targetState: "delayed", reversible: true, action: "dispatch", condition: "garrisonWithoutDispatch"},
    {source: "garrison", target: "attendance", sourceState: "panic", targetState: "schedule", reversible: true, action: "dispatch", condition: "garrisonWithoutDispatch"},
    {source: "garrison", target: "attendance", sourceState: "panic", targetState: "panic", reversible: true, action: "dispatch", condition: "garrisonWithoutDispatch"},
    {source: "garrison", target: "task", sourceState: "available", targetState: "onHold", reversible: true, action: "task"},
    {source: "garrison", target: "task", sourceState: "dispatchActivity", targetState: "onHold", reversible: true, action: "task"},
    {source: "garrison", target: "task", sourceState: "dispatch", targetState: "onHold", reversible: true, action: "task"},
    {source: "garrison", target: "task", sourceState: "dispatchSupport", targetState: "onHold", reversible: true, action: "task"},
    {source: "garrison", target: "garrison", sourceState: "available", targetState: "dispatch", reversible: false, action: "support"},
    {source: "garrison", target: "garrison", sourceState: "dispatchActivity", targetState: "dispatch", reversible: false, action: "support"},
];

export const normalizeDragDropValue = value => String(value || "").toLowerCase().trim();

const matchesDragDropRule = (rule, source, target, sourceState, targetState) => {
    const rSource = normalizeDragDropValue(rule.source);
    const rTarget = normalizeDragDropValue(rule.target);
    const rSourceState = normalizeDragDropValue(rule.sourceState);
    const rTargetState = normalizeDragDropValue(rule.targetState);
    const reversible = Boolean(rule.reversible);

    const directMatch = rSource === source
        && rTarget === target
        && rSourceState === sourceState
        && rTargetState === targetState;

    const inverseMatch = reversible
        && rSource === target
        && rTarget === source
        && rSourceState === targetState
        && rTargetState === sourceState;

    return directMatch || inverseMatch;
};

export const getDashboardDragDropRule = (source, target) => {
    const sourceType = normalizeDragDropValue(source?.type);
    const targetType = normalizeDragDropValue(target?.type);
    const sourceState = normalizeDragDropValue(source?.state);
    const targetState = normalizeDragDropValue(target?.state);

    return DRAG_DROP_MATRIX.find(rule => matchesDragDropRule(rule, sourceType, targetType, sourceState, targetState));
};

const getGarrisonIdFromDragContext = ({source, target}) => {
    if (normalizeDragDropValue(source?.type) === "garrison") return source.id;
    if (normalizeDragDropValue(target?.type) === "garrison") return target.id;
    return null;
};

const hasGarrisonDispatch = (garrisons, garrisonId) => {
    const garrison = (garrisons ?? []).find(item => String(item.garrisonId) === String(garrisonId));
    return Boolean(garrison?.dispatchId);
};

export const isDashboardDragDropAllowed = (rule, context) => {
    if (!rule) return false;
    if (!rule.condition) return true;

    if (rule.condition === "garrisonWithoutDispatch") {
        const garrisonId = getGarrisonIdFromDragContext(context);
        return !hasGarrisonDispatch(context.garrisons, garrisonId);
    }

    return true;
};
